<template>
  <div v-show="isActive" :id="id" :aria-labelledby="`tab_${id}`" role="tabpanel">
    <slot></slot>
  </div>
</template>

<script setup>
import {
  inject, ref, onBeforeMount, watch, defineProps,
} from 'vue';
import { slugify } from '@/utils/string';

const addTab = inject('addTab');
const activeTabHash = inject('activeTabHash');

const props = defineProps(['title']);

const id = ref('');
const hash = ref('');
const isActive = ref(false);

onBeforeMount(() => {
  id.value = slugify(props.title);
  hash.value = `#${id.value}`;

  isActive.value = (hash.value && hash.value === activeTabHash.value);

  addTab({
    title: props.title,
    hash: hash.value,
    id: id.value,
  });
});

watch(activeTabHash, (newHash) => {
  isActive.value = newHash === hash.value;
});
</script>
